export default __webpack_public_path__ + "static/media/warning--towing--g1.e4f069b4.png";